import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../../../../icon';
import Paragraph from '../../../../paragraph';
import TextSkeleton from '../../../../skeletons/text-skeleton';
import SolidIcon from '../../../../solid-icon';
import { CONTENT_TYPES } from '../../constants';

const RowItem = ({ contentType = 'icon-check', text = null, loading = false }) => {
  const rowItemClasses = classNames('ws-ui-plan-row-item');

  const content = () => {
    switch (contentType) {
      case CONTENT_TYPES['icon-minus']:
        return (
          <span className="ws-ui-plan-row-item--icon-minus">
            <Icon glyph="minus" type="inherit" />
          </span>
        );
      case CONTENT_TYPES.text:
        return <Paragraph>{text}</Paragraph>;
      case CONTENT_TYPES['icon-not-available']:
        return <SolidIcon glyph="clear-search" type="error" size={14} strokeWidth={3} />;
      case CONTENT_TYPES['icon-check']:
      default:
        return <SolidIcon glyph="check" type="dark" size={14} strokeWidth={3} />;
    }
  };

  if (loading) {
    return (
      <div className={rowItemClasses}>
        <div className="ws-ui-plan-row-item__skeleton-wrapper">
          <Paragraph>
            <TextSkeleton width="24px" />
          </Paragraph>
        </div>
      </div>
    );
  }

  return <div className={rowItemClasses}>{content()}</div>;
};

RowItem.propTypes = {
  contentType: PropTypes.oneOf(Object.values(CONTENT_TYPES)),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.bool,
};

export default RowItem;
